<template>
  <section id="nosotros" class="section-padding gradient-corporate">
    <div class="container-custom">
      <!-- Title -->
      <div class="text-center mb-16 animate-fade-in-up">
        <h2 class="section-title text-white">{{ $t('values.title') }}</h2>
      </div>

      <!-- Values Grid -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        <!-- Valor 1: Rapidez -->
        <div
          class="group relative bg-white/10 backdrop-blur-sm hover:bg-white rounded-2xl p-8 transition-all duration-300 hover:transform hover:-translate-y-2 hover:shadow-2xl border border-white/20 animate-fade-in-up"
        >
          <div class="absolute top-0 left-0 right-0 h-1 bg-accent rounded-t-2xl transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>

          <div class="flex flex-col items-center text-center space-y-4">
            <div class="w-20 h-20 rounded-full bg-white/20 group-hover:bg-accent flex items-center justify-center transition-colors duration-300">
              <font-awesome-icon
                icon="bolt"
                class="text-4xl text-white group-hover:scale-110 transition-transform duration-300"
              />
            </div>

            <h4 class="text-2xl font-bold text-white group-hover:text-navy-500 transition-colors">
              {{ $t('values.speed.title') }}
            </h4>

            <p class="text-white/90 group-hover:text-navy-600 leading-relaxed transition-colors">
              {{ $t('values.speed.description') }}
            </p>
          </div>
        </div>

        <!-- Valor 2: Confianza -->
        <div
          class="group relative bg-white/10 backdrop-blur-sm hover:bg-white rounded-2xl p-8 transition-all duration-300 hover:transform hover:-translate-y-2 hover:shadow-2xl border border-white/20 animate-fade-in-up delay-100"
        >
          <div class="absolute top-0 left-0 right-0 h-1 bg-accent rounded-t-2xl transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>

          <div class="flex flex-col items-center text-center space-y-4">
            <div class="w-20 h-20 rounded-full bg-white/20 group-hover:bg-accent flex items-center justify-center transition-colors duration-300">
              <font-awesome-icon
                icon="handshake"
                class="text-4xl text-white group-hover:scale-110 transition-transform duration-300"
              />
            </div>

            <h4 class="text-2xl font-bold text-white group-hover:text-navy-500 transition-colors">
              {{ $t('values.trust.title') }}
            </h4>

            <p class="text-white/90 group-hover:text-navy-600 leading-relaxed transition-colors">
              {{ $t('values.trust.description') }}
            </p>
          </div>
        </div>

        <!-- Valor 3: Seguridad -->
        <div
          class="group relative bg-white/10 backdrop-blur-sm hover:bg-white rounded-2xl p-8 transition-all duration-300 hover:transform hover:-translate-y-2 hover:shadow-2xl border border-white/20 animate-fade-in-up delay-200"
        >
          <div class="absolute top-0 left-0 right-0 h-1 bg-accent rounded-t-2xl transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>

          <div class="flex flex-col items-center text-center space-y-4">
            <div class="w-20 h-20 rounded-full bg-white/20 group-hover:bg-accent flex items-center justify-center transition-colors duration-300">
              <font-awesome-icon
                icon="shield-alt"
                class="text-4xl text-white group-hover:scale-110 transition-transform duration-300"
              />
            </div>

            <h4 class="text-2xl font-bold text-white group-hover:text-navy-500 transition-colors">
              {{ $t('values.security.title') }}
            </h4>

            <p class="text-white/90 group-hover:text-navy-600 leading-relaxed transition-colors">
              {{ $t('values.security.description') }}
            </p>
          </div>
        </div>

        <!-- Valor 4: Tecnología -->
        <div
          class="group relative bg-white/10 backdrop-blur-sm hover:bg-white rounded-2xl p-8 transition-all duration-300 hover:transform hover:-translate-y-2 hover:shadow-2xl border border-white/20 animate-fade-in-up delay-300"
        >
          <div class="absolute top-0 left-0 right-0 h-1 bg-accent rounded-t-2xl transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>

          <div class="flex flex-col items-center text-center space-y-4">
            <div class="w-20 h-20 rounded-full bg-white/20 group-hover:bg-accent flex items-center justify-center transition-colors duration-300">
              <font-awesome-icon
                icon="microchip"
                class="text-4xl text-white group-hover:scale-110 transition-transform duration-300"
              />
            </div>

            <h4 class="text-2xl font-bold text-white group-hover:text-navy-500 transition-colors">
              {{ $t('values.technology.title') }}
            </h4>

            <p class="text-white/90 group-hover:text-navy-600 leading-relaxed transition-colors">
              {{ $t('values.technology.description') }}
            </p>
          </div>
        </div>
      </div>

      <!-- Stats Row (Opcional - 25 años) -->
      <div class="mt-16 text-center">
        <div class="inline-block bg-white/10 backdrop-blur-sm rounded-2xl px-12 py-8 border border-white/20">
          <div class="text-6xl font-bold text-accent mb-2">25+</div>
          <div class="text-xl text-white font-medium">Años moviendo Chile</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
// No se necesita lógica adicional
</script>
